import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DialogContent } from '@mui/material';
import Dialog from "./Dialog.js";
export default function CascadingMenuHelpDialog({ onClose, helpText, label, }) {
    return (_jsx(Dialog, { open: true, onClose: onClose, title: "Help", titleNode: label ? _jsxs(_Fragment, { children: ["Help: ", label] }) : undefined, onClick: e => {
            e.stopPropagation();
        }, onMouseDown: e => {
            e.stopPropagation();
        }, children: _jsx(DialogContent, { children: helpText }) }));
}
